<template>
    <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
        :opacity="detailsOpacity" 
        fill-rule="evenodd" 
        clip-rule="evenodd" d="M13.4224 13.4221C13.8123 13.0322 14.4445 13.0322 14.8345 13.4221L18.7078 17.2954C19.0977 17.6853 19.0977 18.3176 18.7078 18.7075C18.3178 19.0975 17.6856 19.0975 17.2956 18.7075L13.4224 14.8342C13.0324 14.4443 13.0324 13.8121 13.4224 13.4221Z" 
        :fill="color"/>
        <path 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M6.70457 18.7075C6.31463 19.0975 5.6824 19.0975 5.29246 18.7075C4.90251 18.3176 4.90251 17.6854 5.29246 17.2954L10.5879 12L5.29246 6.70457C4.90251 6.31463 4.90251 5.6824 5.29246 5.29246C5.6824 4.90251 6.31463 4.90251 6.70457 5.29246L12 10.5879L17.2954 5.29246C17.6854 4.90251 18.3176 4.90251 18.7075 5.29246C19.0975 5.6824 19.0975 6.31463 18.7075 6.70457L6.70457 18.7075Z" 
        :fill="color"/>
    </svg>
</template>
<script>
    export default {
        props:['width','height','color','detailsOpacity'],
    }
</script>

<style scoped>
</style>
